/**
 * Client-side beacon to /api/track. Fire-and-forget — never throws,
 * never blocks UI. Uses fetch with keepalive so it survives page unload
 * (e.g. user clicking an external link right as a pageview fires).
 */
export function track(event: string, meta?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  const body = JSON.stringify({
    event,
    path: window.location.pathname,
    version: __APP_VERSION__,
    meta,
  });
  try {
    fetch("/api/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* ignore — telemetry must never break the app */
  }
}
